import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index.vue'
import LayoutWithoutResize from "@/layout/LayoutWithoutResize.vue";
import LayoutWithFullHeight from "@/layout/LayoutWithFullHeight.vue";
import rfidRoute from "@/router/rfidRoute";

Vue.use(Router);

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/

export default new Router({
  // mode: 'history',  // Enable this if you need.
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  base: process.env.BASE_URL,
  routes: [

    {
      path: '/404',
      component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
      meta: {hidden: true}
    },
    // {
    //   path: '/login',
    //   component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    //   meta: { hidden: true }
    // },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      children: [
        {
          path: 'dashboard',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
          meta: {
            title: 'Dashboard',
            icon: 'dashboard'
          }
        }
      ]
    },
    {
      path: '/scanforacceptpacketgeton',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforacceptpacketgeton/index.vue'),
          meta: {
            title: 'ScanForAcceptPacketGetOn',
            icon: 'form'
          }
        }
      ]
    },
    {
     path: '/scanforacceptpacketgetonnew',
     component: Layout,
     children: [
       {
         path: 'index',
         component: () => import(/* webpackChunkName: "form" */ '@/views/scanforacceptpacketgetonnew/index.vue'),
         meta: {
           title: 'ScanForAcceptPacketGetOnNew',
           icon: 'form'
         }
       }
     ]
    },
    {
      path: '/scanforacceptpacket',
      component: LayoutWithoutResize,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforacceptpacket/index.vue'),
          meta: {
            title: 'ScanForAcceptPacket',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforacceptpacketnew',
      component: LayoutWithoutResize,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforacceptpacketnew/index.vue'),
          meta: {
            title: 'ScanForAcceptPacketNew',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforoutbound_getoff',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforoutbound_getoff/index.vue'),
          meta: {
            title: 'ScanForOutbound_GetOff',
            icon: 'form'
          }
        }
      ]
    }, {
      path: '/scanforoutbound_getoff',
      component: Layout,
      children: [
        {
          path: 'index2',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforoutbound_getoff/index2.vue'),
          meta: {
            title: 'ScanForOutbound_GetOff',
            icon: 'form'
          }
        }
      ]
    }, {
      path: '/scanforgeton',
      component: LayoutWithoutResize,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforgeton/index.vue'),
          meta: {
            title: 'ScanForGetOn',
            icon: 'form'
          }
        }
      ]
    }, {
      path: '/scanforgetonnew',
      component: LayoutWithoutResize,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforgetonnew/index.vue'),
          meta: {
            title: 'ScanForGetOnNew',
            icon: 'form'
          }
        }
      ]
    }, {
      path: '/camera_apply',
      component: LayoutWithoutResize,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/camera_apply/index.vue'),
          meta: {
            title: 'camera_apply',
            icon: 'form'
          }
        }
      ]
    }, {
      path: '/FindNoTransCodeStatus',
      component: LayoutWithoutResize,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "FindNoTransCodeStatus" */ '@/views/FindNoTransCodeStatus/index.vue'),
          meta: {
            title: 'camera_apply',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/FindNoTransCodeStatusNew',
      component: LayoutWithoutResize,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "FindNoTransCodeStatusNew" */ '@/views/FindNoTransCodeStatusNew/index.vue'),
          meta: {
            title: 'FindNoTransCodeStatusNew',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforsixscan',
      component: LayoutWithoutResize,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforsixscan/index.vue'),
          meta: {
            title: 'ScanForSixScan',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/loginfo',
      component: LayoutWithoutResize,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/loginfo/index.vue'),
          meta: {
            title: 'ScanForSixScan',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforsixscannew',
      component: LayoutWithoutResize,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforsixscannew/index.vue'),
          meta: {
            title: 'ScanForSixScanNew',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforweighbridge',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforweighbridge/index.vue'),
          meta: {
            title: 'ScanForWeighbridge',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforweighbridgenew',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforweighbridgenew/index.vue'),
          meta: {
            title: 'ScanForWeighbridgeNew',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforarrivecar',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforarrivecar/index.vue'),
          meta: {
            title: 'ScanForArriveCar',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforarrivecarnew',
      component: LayoutWithFullHeight,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforarrivecarnew/index.vue'),
          meta: {
            title: 'ScanForArriveCarNew',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforresolvecar',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforresolvecar/index.vue'),
          meta: {
            title: 'ScanForResolveCar',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforresolvecarnew',
      component: LayoutWithFullHeight,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforresolvecarnew/index.vue'),
          meta: {
            title: 'ScanForResolveCarNew',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforsealcar',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforsealcar/index.vue'),
          meta: {
            title: 'ScanForSealCar',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforsealcarnew',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforsealcarnew/index.vue'),
          meta: {
            title: 'ScanForSealCarNew',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanfordepart',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanfordepart/index.vue'),
          meta: {
            title: 'ScanForDepart',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanfordepartnew',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanfordepartnew/index.vue'),
          meta: {
            title: 'ScanForDepartNew',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforbubblepackage',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforbubblepackage/index.vue'),
          meta: {
            title: 'ScanForBubblePackage',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforbubblepackagenew',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforbubblepackagenew/index.vue'),
          meta: {
            title: 'ScanForBubblePackageNew',
            icon: 'form'
          }
        }
      ]
    },
    {
      // path: '/about',
      // component: Layout,

      path: '/about',
      component: () => import(/* webpackChunkName: "about" */ '@/views/about/index.vue'),
      meta: {
        title: 'About',
        icon: 'form'
      }

    },
    {
      path: '/basedatauploadandsearch',
      // component: Layout,
      // children: [
      //   {
      // path: 'index',
      component: () => import(/* webpackChunkName: "form" */ '@/views/basedatauploadandsearch/index.vue'),
      meta: {
        title: 'BaseDataUploadAndSearch',
        icon: 'form'
      }
      //   }
      // ]
    },
    {
      path: '/print',
      component: Layout,
      redirect: '/print/reprint',
      meta: {
        title: 'Print',
        icon: 'print'
      },
      children: [
        {
          path: 'reprint',
          component: () => import(/* webpackChunkName: "tree" */ '@/views/print/reprint/index.vue'),
          meta: {
            title: 'Reprint',
            icon: 'reprint'
          }
        },
        {
          path: 'packageprint',
          component: () => import(/* webpackChunkName: "tree" */ '@/views/print/packageprint/index.vue'),
          meta: {
            title: 'PackagePrint',
            icon: 'packageprint'
          }
        }
        ,
        {
          path: 'packageprintnew',
          component: () => import(/* webpackChunkName: "tree" */ '@/views/print/packageprintnew/index.vue'),
          meta: {
            title: 'PackagePrintNew',
            icon: 'packageprintnew'
          }
        }
        ,
        {
          path: 'inboundvirtualpacketprint',
          component: () => import(/* webpackChunkName: "tree" */ '@/views/print/inboundvirtualpacketprint/index.vue'),
          meta: {
            title: 'InboundVirtualPacketPrint',
            icon: 'inboundvirtualpacketprint'
          }
        },
        {
          path: 'inboundvirtualpacketprintnew',
          component: () => import(/* webpackChunkName: "tree" */ '@/views/print/inboundvirtualpacketprintnew/index.vue'),
          meta: {
            title: 'InboundVirtualPacketPrintNew',
            icon: 'inboundvirtualpacketprintnew'
          }
        },
        {
          path: 'bigbagprintnew',
          component: () => import(/* webpackChunkName: "tree" */ '@/views/print/bigbagprintnew/index.vue'),
          meta: {
            title: 'BigBagPrintNew',
            icon: 'bigbagprintnew'
          }
        }
      ]
    },
    {
      path: '/rfid',
      component: () => import('@/views/rfid/RfidLayout.vue'),
      meta: {
        title: 'Dashboard',
        icon: 'dashboard'
      },
      children: [
        {
          path: 'in',
          component: () => import('@/views/rfid/In/InStock.vue'),
          meta: {
            title: 'Dashboard',
            icon: 'dashboard'
          },
        }
      ]
    },
    {
      path: '*',
      redirect: '/404',
      meta: {hidden: true}
    },
    {
      path: '/settingBtn',
      component: () => import(/* webpackChunkName: "tree" */ '@/views/miniPage/LoginSetting.vue'),
      meta: {hidden: true}
    },
    {
      path: '/scanforbackflow',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforbackflow/index.vue'),
          meta: {
            title: 'ScanForBackFlow',
            icon: 'form'
          }
        }
      ]
    },

    {
      path: '/scanforroughsorting',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforroughsorting/index.vue'),
          meta: {
            title: 'ScanForRoughSorting',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanforrepairandsupply',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanforrepairandsupply/index.vue'),
          meta: {
            title: 'ScanForRepairAndSupply',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/scanfordiscard',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/scanfordiscard/index.vue'),
          meta: {
            title: 'ScanForDiscard',
            icon: 'form'
          }
        }
      ]
    },
    {
      path: '/bdfm',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import(/* webpackChunkName: "form" */ '@/views/bdfm/index.vue'),
          meta: {
            title: 'bdfm',
            icon: 'form'
          }
        }
      ]
    },


    // {
    //   path: '/print',
    //   component: Layout,
    //   redirect: '/print/reprint',
    //   meta: {
    //     title: 'Print',
    //     icon: 'print'
    //   },
    //   children: [
    //     {
    //       path: 'reprint',
    //       component: () => import(/* webpackChunkName: "form" */ '@/views/print/reprint/index.vue'),
    //       meta: {
    //         title: 'Reprint',
    //         icon: 'reprint'
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: '/example',
    //   component: Layout,
    //   redirect: '/example/tree',
    //   meta: {
    //     title: 'Example',
    //     icon: 'example'
    //   },
    //   children: [
    //     {
    //       path: 'tree',
    //       component: () => import(/* webpackChunkName: "tree" */ '@/views/tree/index.vue'),
    //       meta: {
    //         title: 'Tree',
    //         icon: 'tree'
    //       }
    //     },
    //     {
    //       path: 'table',
    //       component: () => import(/* webpackChunkName: "table" */ '@/views/table/index.vue'),
    //       meta: {
    //         title: 'Table',
    //         icon: 'table'
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: '/form',
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'index',
    //       component: () => import(/* webpackChunkName: "form" */ '@/views/form/index.vue'),
    //       meta: {
    //         title: 'Form',
    //         icon: 'form'
    //       }
    //     }
    //   ]
    // },

    // {
    //   path: '/nested',
    //   component: Layout,
    //   redirect: '/nested/menu1',
    //   meta: {
    //     title: 'Nested',
    //     icon: 'nested'
    //   },
    //   children: [
    //     {

    //       path: 'menu1',
    //       component: () => import(/* webpackChunkName: "menu1" */ '@/views/nested/menu1/index.vue'),
    //       redirect: '/nested/menu1/menu1-1',
    //       meta: { title: 'Menu1' },
    //       children: [
    //         {
    //           path: 'menu1-1',
    //           component: () => import(/* webpackChunkName: "menu1-1" */ '@/views/nested/menu1/menu1-1/index.vue'),
    //           meta: { title: 'Menu1-1' }
    //         },
    //         {
    //           path: 'menu1-2',
    //           component: () => import(/* webpackChunkName: "menu1-2" */ '@/views/nested/menu1/menu1-2/index.vue'),
    //           redirect: '/nested/menu1/menu1-2/menu1-2-1',
    //           meta: { title: 'Menu1-2' },
    //           children: [
    //             {
    //               path: 'menu1-2-1',
    //               component: () => import(/* webpackChunkName: "menu1-2-1" */ '@/views/nested/menu1/menu1-2/menu1-2-1/index.vue'),
    //               meta: { title: 'Menu1-2-1' }
    //             },
    //             {
    //               path: 'menu1-2-2',
    //               component: () => import(/* webpackChunkName: "menu1-2-2" */ '@/views/nested/menu1/menu1-2/menu1-2-2/index.vue'),
    //               meta: { title: 'Menu1-2-2' }
    //             }
    //           ]
    //         },
    //         {
    //           path: 'menu1-3',
    //           component: () => import(/* webpackChunkName: "menu1-3" */ '@/views/nested/menu1/menu1-3/index.vue'),
    //           meta: { title: 'Menu1-3' }
    //         }
    //       ]
    //     },
    //     {
    //       path: 'menu2',
    //       component: () => import(/* webpackChunkName: "menu2" */ '@/views/nested/menu2/index.vue'),
    //       meta: { title: 'Menu2' }
    //     }
    //   ]
    // },
    // {
    //   path: 'external-link',
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'https://github.com/Armour/vue-typescript-admin-template',
    //       meta: {
    //         title: 'External Link',
    //         icon: 'link'
    //       }
    //     }
    //   ]
    // },

  ]
})
